import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { header } from "../globalVariables";
import { api, cleanJSON, isJSON, robustJsonParse } from "../pureFunctions";

export function FilterGenerator({ data, allKacheln, editSettings, respField }) {
   const [loading, setLoading] = useState("");
   const [prompt, setPrompt] = useState("");

   async function genFilter() {
      console.log(allKacheln);

      const onlyNames = Object.values(allKacheln).map((item) => {
         return {
            stufenId: item.id,
            stufenHeading: item.heading,
            kachel: item.kachel.map((kachelItem) => {
               return {
                  kachelHeading: kachelItem.heading,
                  kachelId: kachelItem.kachelId,
                  fields: kachelItem.fields.flat().map((fieldItem) => {
                     return {
                        fieldHeading: fieldItem.heading,
                        fieldId: fieldItem.name,
                        ...(fieldItem.options ? { options: fieldItem.options } : {}),
                     };
                  }),
               };
            }),
         };
      });

      console.log(onlyNames);

      const content = await api
         .post(
            `api/ai_prompt`,
            {
               // model: "sonnet-5-5",
               model: "ministral-14b",
               messages: [
                  { role: "system", content: systemPrompt.replace("$ALLKACHELN", JSON.stringify(onlyNames)) },
                  { role: "user", content: prompt },
               ],
               // outputConfig: outputConfig,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            console.log(data?.data?.content);

            return robustJsonParse(data?.data?.content ?? data?.content);
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
         });

      console.log(content);

      editSettings(respField, JSON.stringify(content,null,2))
   }

   /* 
   {
  "op": "===",
  "field": "kachel_status_uebergabe",
  "value": 4
} */
   return (
      <>
         <Row>
            <Col>
               <Form.Group className="mb-3" controlId="prompt">
                  <Form.Label>Prompt</Form.Label>
                  <Form.Control
                     autoComplete="off"
                     placeholder="Das Feld soll angezeigt werden, wenn die Kachel Übergabe Einkauf an Haus abgeschlossen ist oder die Projektstufe Datenblatt abgeschlossen ist."
                     style={{ minHeight: "120px", fieldSizing: "content" }}
                     as="textarea"
                     onChange={(e) => {
                        setPrompt(e.target.value);
                     }}
                     value={prompt}
                  />
               </Form.Group>
            </Col>
         </Row>

         <div className="d-flex justify-content-end mt-2">
            <Button
               variant="secondary"
               onClick={() => {
                  genFilter();
               }}
            >
               Filter generieren
            </Button>
         </div>
      </>
   );
}

const systemPrompt = `
Ich nutze diese Funktion zum Filtern.



function evaluateRule(item, rule) {
   // Falls es eine Untergruppe ist (OR / AND)
   if (!rule || Object.keys(rule).length === 0) {
      return true;
   }

   if (rule.logic) {
      if (rule.logic === "and") {
         return rule.rules.every((subRule) => evaluateRule(item, subRule));
      }
      if (rule.logic === "or") {
         return rule.rules.some((subRule) => evaluateRule(item, subRule));
      }
   }

   // Die eigentliche Feld-Prüfung (Logik-Zentrum)
   const value = item[rule.field];

   switch (rule.op) {
      case "===":
         return value === rule.value;
      case "!==":
         return value !== rule.value;
      case "<=":
         return value <= rule.value;
      case ">=":
         return value >= rule.value;
      case "<":
         return value < rule.value;
      case ">":
         return value > rule.value;
      case "hasValue":
         return value !== undefined && value !== null && value !== "";
      case "valid":
         return value !== undefined && value !== null;
      case "afterDays":
         return Date.now() + rule.value * 24 * 60 * 60 * 1000 > new Date(value).getTime();
      case "beforeDays":
         return Date.now() + rule.value * 24 * 60 * 60 * 1000 < new Date(value).getTime();

      case "has_image":
         return item.images && item.images.length > 0;
      default:
         return true;
   }
}

Hier ist noch ein Beispiel für einen mehrschichtigen Filter
{
         "logic": "or",
         "rules": [
            {
               "logic": "and",
               "rules": [
                  { "field": "bmweitererverlauf", op: "===", value: "Auftrag kommt" },
                  { "field": "projekt_status_bewertungsergebnis", op: "===", value: 4 },
               ],
            },
            { "field": "dbin_a_o_b", op: "===", value: "Auftrag" },
         ],
      }

Wenn eine Kachel beispielKachelName fertig abgeschlossen ist, heißt das, dass kachel_status_ + kachelId den Wert 4 haben muss.
Wenn eine Projektstufe beispielProjektstufenName fertig abgeschlossen ist, heißt das, dass projekt_status_ + stufenId den Wert 4 haben muss.
Stelle sicher, dass projekt_status_ und kachel_status_ nicht verwechselt wird.
Den wert von dem Heading wird nie vorne bei der Fieldbezeichnung angefügt.
Erstelle mit den folgenden Anweisungen passende Filter im JSON-Format. 

Hier sind die ids und headings alle stufen und kacheln und felder:

$ALLKACHELN
   
Beziehe dich nur auf die Felder, die wirklich genannt werden. Das Objekt darf maximal zwei ebenen tief sein.
      Antworte ausschließlich mit dem JSON-Objekt, ohne Erklärung und ohne Markdown.
`;
